export const CONSENT_SECTION_1 = {
  title: '1. Methods of communication and consent can consist of, but are not limited to:',
  items: [
    'Email',
    'Text Messages',
    'Phone Calls',
    'DropboxSign, HelloSign (HIPAA compliant signature platform)',
    "Assessments required by insurance and/or medical necessity for development of the client's Treatment Plan",
  ],
};

export const CONSENT_SECTION_2 = {
  title: '2. General Considerations:',
  items: [
    'Email communication will be considered and treated with the same degree of privacy and confidentiality as written medical records.',
    {
      title:
        'Standard email communication services such as Gmail, Yahoo, AOL, etc. are not secure. Although unlikely, this means that the email messages are not encrypted and can be potentially intercepted and ready by unauthorized individuals.',
      items: [
        'Fort Supervising, Clinical, and Corporate Staff have corporate domain email addresses (@fortahealth.com).',
        'Forta staff may use encrypted methods of email delivery, however, this method is not used in all email correspondence.',
      ],
    },
    'Text messages are typically a platform of communication that results in timely responses and/or information sharing. Forta staff will never input Protected Health Information (PHI) in a text message. Text messages are not considered HIPAA compliant, therefore any communication rendered via text messages should be carefully composed to avoid any violations of HIPAA compliance.',
    'Using platforms, such as DropboxSign, which are HIPAA compliant and permit convenient delivery of important documents for consent purposes.',
    'All documents are stored in a HIPAA compliant Forta GSuite account for 7yrs after services are rendered.',
  ],
};

export const CONSENT_SECTION_3 = {
  title: '3. Forta Staff Responsibilities:',
  items: [
    "Staff may attempt to electronically confirm you've received correspondence by requesting a return response to all email messages.",
    'Forta staff may route your email messages to other members of staff for information purposes or for expediting a response.',
    'Forta staff will attempt to respond to your email message within three (3) business day (Monday-Friday, non-holidays). If you do not receive a response as expected within three (3) business days, please contact the Clinical Lead at clinicalsupervisor@fortahealth.com.',
    "Copies of emails sent and received from into you could be incorporated into the client's medical record. You are advised to retain all electronic correspondence for your own files.",
  ],
};

export const CONSENT_SECTION_4 = {
  title: '4. Client-Parent(s)/Legal Guardian(s) Responsibilities:',
  items: [
    'Email and text messages should not be used for emergencies or time sensitive situation. In the event of a medical emergency, you should immediately call 911. For emergent or time sensitive situations, you should contact your immediate Clinical Lead or Client Success Manager via phone.',
    'Email messages should be concise. Please arrange for an appointment with your Clinical Lead or Client Success Manager if the issue or inquiry is too complex or sensitive to discuss via email.',
    "For accurate measurement, Forta requests a response or confirmation from you, the client or parent/legal guardian of the client, that the email has been received and understood is provided within 24 to 48 hours after delivery. Failure to do so may result in processing delays, scheduling adjustments, and discrepancies in services for the client's ABA services.",
  ],
};

export const CONSENT_SECTION_5 = {
  title: '5. Consent for Electronic Delivery of Communication and Documents:',
  items: [
    'You have read and understood the above description of the risks and responsibilities associated with electronic communication with Forta staff.',
    'You acknowledge that commonly used communication methods are not secure and fall outside of security requirements set forth by HIPAA compliance for the transmission of PHI.',
    'You understand that you may revoke this consent at any time, however, you cannot revoke consent for communication and document delivery that has already taken place.',
    'You agree and release Forta staff from any and all liability that may occur due to electronic communication from a non-secure network.',
    'You agree to be held accountable and comply with the client or parent/legal guardian responsibilities as outlined in this consent.',
  ],
};
